import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { ActivationCode } from '../model/activationCode';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EmailData } from '../model/EmailData';
import { UserService } from '../service/user.service';
import { FormControl, FormGroup } from '@angular/forms';
import { FormHelper } from '../util/formHelper';
import { Overlay } from "@angular/cdk/overlay";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { EmailDefaultData } from '../model/EmailDefaultData';


@Component({
  selector: 'app-send-email-dialog',
  templateUrl: './send-email-dialog.component.html',
  styleUrls: ['./send-email-dialog.component.css']
})
export class SendEmailDialogComponent implements OnInit {

  activationCode: ActivationCode;
  userOwnerId: string;
  ownerEmail: string;

  toEmail: string;
  ccEmail: string;

  defaultSubject: string;
  subject: string;

  defaultHtmlContent: string;
  htmlContent: string;

  language: string;

  emailToSendData: EmailData;
  defaultEmailData: EmailDefaultData;


  toEmailInvalidError: boolean = false;
  ccEmailInvalidError: boolean = false;
  subjectInvalidError: boolean = false;
  htmlContentInvalidError: boolean = false;
  errorDuringSending: boolean = false;
  codeNotPresent: boolean = false;

  sendWelcomeEmailSubscription: Subscription;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    height: 'auto',
    minHeight: '350px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    enableToolbar: false,
    showToolbar: false
  };

  emailDataForm = new FormGroup({
    toEmail: new FormControl(''),
    ccEmail: new FormControl(''),
    subject: new FormControl('')
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private userService: UserService,
    public dialogRef: MatDialogRef<SendEmailDialogComponent>,
    private overlay: Overlay
  ) {

    this.activationCode = data.code;
    this.userOwnerId = data.owner.id;
    this.ownerEmail = data.owner.email
    this.language = data.language;

    this.toEmail = "";
    this.ccEmail = "";

    if (data.defaultEmail) {

      this.defaultHtmlContent = data.defaultEmail.message;

      this.htmlContent = this.replacePlaceholderWithActivationCode();
      this.defaultSubject = data.defaultEmail.subject;
      this.subject = this.defaultSubject;

    } else {
      this.defaultHtmlContent = 'Benvenuto in Pilomat P-Connect!<br><br>Puoi iniziare ad usufruire del servizio scaricando l\'app P-Connect.<br><div><img src="https://pilomat.1control.eu/assets/img/p-connect_app_logo100x100.jpg"><br>Play Store:<div>https://play.google.com/store/apps/details?id=it.onecontrol.app.pilomat.and<br><br>App Store Apple:</div><div>https://apps.apple.com/us/app/pilomat-p-connect/id1570641437<br><br>Una volta scaricata, usa il codice presente di seguito per abilitare i permessi ricevuti:</div></div><div><br></div><div><b>Codice: </b></div>';
      this.htmlContent = this.defaultHtmlContent + this.activationCode.code;
      this.defaultSubject = "Benvenuto in P-Connect!";
      this.subject = this.defaultSubject;
    }

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {

    if (this.sendWelcomeEmailSubscription) {
      this.sendWelcomeEmailSubscription.unsubscribe();
    }
  }



  sendEmailControls() {

    this.codeNotPresent = false;
    this.toEmailInvalidError = false;
    this.ccEmailInvalidError = false;
    this.subjectInvalidError = false;
    this.htmlContentInvalidError = false;
    this.errorDuringSending = false;

    if (!FormHelper.isValidEmail(this.toEmail)) {
      this.toEmailInvalidError = true;
      return;
    }

    if (this.ccEmail != "" && !FormHelper.isValidEmail(this.ccEmail)) {
      this.ccEmailInvalidError = true;
      return;
    }

    if (!this.htmlContent.includes(this.activationCode.code)) {
      this.codeNotPresent = true;
      return;
    }

    if (this.replaceActivationCodeWithPlaceholder() != this.defaultHtmlContent || this.subject != this.defaultSubject) {
      let message = $localize`:@@send_email_dialog_email_content_changed:Il contenuto della email è stato modificato. Vuoi salvarlo come predefinito?`;
      let confirmMessage = $localize`:@@send_email_dialog_email_content_changed_confirm:Salva e invia`;
      let cancelMessage = $localize`:@@send_email_dialog_email_content_changed_cancel:Invia senza salvare`;


      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const confirmdialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "550px",
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      confirmdialogRef.afterClosed().subscribe((response) => {
        if (response == true) {
          this.defaultEmailData = new EmailDefaultData();
          this.defaultEmailData.message = this.replaceActivationCodeWithPlaceholder();
          this.defaultEmailData.subject = this.subject;
          this.defaultEmailData.language = this.language;

          this.userService.setOwnerDefaultEmailData(this.userOwnerId, this.defaultEmailData).subscribe((response) => {

            this.sendEmail(true);

          }, (err) => {
            // console.log(err);
          });
        }

        if (response == false) {
          this.sendEmail(false);
        }
      });
    } else {
      this.sendEmail(false);
    }
  }

  sendEmail(newDefaultEmail) {
    let ownerEmailDomain = this.ownerEmail.split("@")[1];
    let noreplyAtownerEmailDomain = "noreply@" + ownerEmailDomain;

    this.emailToSendData = new EmailData();
    this.emailToSendData.message = this.htmlContent;
    this.emailToSendData.subject = this.subject;
    // this.emailToSendData.fromEmail = "admin@1control.it";
    this.emailToSendData.fromEmail = "noreply@pilomat.com";
    // this.emailToSendData.fromName = this.ownerEmail;
    this.emailToSendData.fromName = noreplyAtownerEmailDomain;
    this.emailToSendData.toEmail = this.toEmail;

    if (this.ccEmail != "") {
      this.emailToSendData.ccEmail = this.ccEmail;
    }

    this.emailToSendData.replyToEmail = "noreply@pilomat.com";


    this.sendWelcomeEmailSubscription = this.userService.sendActivationCodeEmail(this.emailToSendData, this.activationCode.id.toString(), this.userOwnerId).subscribe((response) => {
      let message = $localize`:@@send_email_dialog_email_sent_successfully:Email inviata con successo`;
      let header = "";

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const confirmdialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "350px",
        data: { message, header },
        scrollStrategy,
      });

      confirmdialogRef.afterClosed().subscribe((response) => {
        if (newDefaultEmail) {
          this.dialogRef.close(this.defaultEmailData);
        } else {
          this.dialogRef.close("true");

        }
      });

    }, (err) => {
      // console.log(err);
      this.errorDuringSending = true;

    });
  }

  replaceActivationCodeWithPlaceholder(): string {
    return this.htmlContent.replace(this.activationCode.code, "{[ActivationCodePlaceHolder]}");
  }


  replacePlaceholderWithActivationCode(): string {
    return this.defaultHtmlContent.replace("{[ActivationCodePlaceHolder]}", this.activationCode.code);
  }



  closeDialog() {
    this.dialogRef.close(null);
  }
}
